










































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { DppFinal, GestacaoFormData } from '../../../../back/src/types';
import {
  localPartoItens,
  localPartoLowerValues,
  sexoBebeItens,
  avisosGestacao,
} from '../../utils/constants';
import { decimalBrMask, alturaCm, pesoGramas } from '../../utils/functions';

import Carregando from '../Carregando.vue';
import Confirmar from '../Confirmar.vue';

export default Vue.extend({
  name: 'TheGestacoesFormAtual',
  components: {
    Carregando,
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      loading: {
        form: false,
        submit: false,
      },
      avisosGestacao,
      valid: false,
      menuDataUltimaMenstruacao: false,
      menuDataExameUs: false,
      igDumSemanas: '',
      igDumDias: '',
      dppDumInvalida: false,
      dppUsInvalida: false,
      form: {
        dataUltimaMenstruacao: '',
        dppFinalDum: false,
        dataExameUs: '',
        igExameUsSemanas: '',
        igExameUsDias: '',
        dppFinalUs: false,
        alturaM: this.paciente.altura_cm ? (this.paciente.altura_cm / 100).toFixed(2) : null,
        pesoInicialKg: null,
        gestacaoSolo: false,
        gestacaoGemelar: false,
        gestacaoGemelarObs: '',
        nome1: '',
        sexo1: '',
        nome2: '',
        sexo2: '',
        medico: '',
        pediatra: '',
        doula: '',
        fotografa: '',
        localParto: null,
        localPartoOutro: null,
        observacoes: '',
        obs_pre_natal: '',
        flagDg: false,
        flagPa: false,
        flagRc: false,
        flagHg: false,
        flagRhNegativo: false,
        flagAr: false,
        flagHt: false,
        flagTf: false,
        primeira_gestacao: false,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
      items: {
        sexoBebe: sexoBebeItens,
        localParto: localPartoItens,
      },
    };
  },
  computed: {
    gestacaoAtual(): Gestacao | null {
      return this.paciente.gestacao_atual;
    },
    disablePrimeiraGestacao(): boolean {
      if (!this.gestacaoAtual) {
        return this.paciente.gestacoes.length > 0;
      }
      return this.paciente.gestacoes.length > 1;
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    vColLabelClass(): string {
      return 'pt-1 pb-2 mb-1';
    },
    actionsClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-2';
      }
      return 'd-flex justify-end pt-0 pb-2';
    },
    dataUltimaMenstruacaoFormatada(): string {
      if (this.form.dataUltimaMenstruacao) {
        const momentDataUltimaMenstruacao = moment(this.form.dataUltimaMenstruacao);
        if (momentDataUltimaMenstruacao.isValid()) {
          return momentDataUltimaMenstruacao.utc().format('DD/MM/YYYY');
        }
      }
      return '';
    },
    dataProvavelPartoDumFormatada(): string {
      if (this.form.dataUltimaMenstruacao) {
        const momentDataProvavelParto = moment(this.form.dataUltimaMenstruacao).add(40, 'w');
        if (momentDataProvavelParto.isValid()) {
          return momentDataProvavelParto.utc().format('DD/MM/YYYY');
        }
      }
      return '';
    },
    dataExameUsFormatada(): string {
      if (this.form.dataExameUs) {
        const momentDataExameUs = moment(this.form.dataExameUs);
        if (momentDataExameUs.isValid()) {
          return momentDataExameUs.utc().format('DD/MM/YYYY');
        }
      }
      return '';
    },
    dataProvavelPartoUsFormatada(): string {
      if (this.form.dataProvavelPartoUs) {
        const dataProvavelPartoUs = moment(this.form.dataProvavelPartoUs);
        if (dataProvavelPartoUs.isValid()) {
          return dataProvavelPartoUs.utc().format('DD/MM/YYYY');
        }
      }
      return '';
    },
    formGestacaoAtual(): Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formGestacaoAtual as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'form.dataUltimaMenstruacao': function (val) {
      if (!val) {
        this.form.dppFinalDum = false;
      }
    },
    // eslint-disable-next-line func-names
    'form.dataExameUs': function (val) {
      if (!val) {
        this.form.dppFinalUs = false;
      }
    },
  },
  mounted() {
    this.alturaMask();
  },
  methods: {
    preencheForm() {
      this.loading.form = true;
      if (this.gestacaoAtual) {
        // DUM
        if (this.gestacaoAtual.data_ultima_menstruacao) {
          const momentDataUltimaMenstruacao = moment(
            this.gestacaoAtual.data_ultima_menstruacao,
          );
          this.form.dataUltimaMenstruacao = momentDataUltimaMenstruacao.isValid()
            ? momentDataUltimaMenstruacao.utc().format('YYYY-MM-DD')
            : '';
        } else {
          this.form.dataUltimaMenstruacao = '';
        }
        this.form.dppFinalDum = this.gestacaoAtual.dpp_final === 'M';
        this.calculaDppDum();
        // DPP US
        if (this.gestacaoAtual.data_exame_us) {
          const momentDataExameUs = moment(
            this.gestacaoAtual.data_exame_us,
          );
          this.form.dataExameUs = momentDataExameUs.isValid()
            ? momentDataExameUs.utc().format('YYYY-MM-DD')
            : '';
        } else {
          this.form.dataExameUs = '';
        }
        this.form.igExameUsSemanas = Math.floor(this.gestacaoAtual.ig_exame_us_dias / 7);
        this.form.igExameUsDias = this.gestacaoAtual.ig_exame_us_dias % 7;
        this.calculaDppUs();
        this.form.dppFinalUs = this.gestacaoAtual.dpp_final === 'U';
        // resto
        this.form.alturaM = this.paciente.altura_cm
          ? (this.paciente.altura_cm / 100).toFixed(2)
          : null;
        this.alturaMask();
        this.form.pesoInicialKg = this.gestacaoAtual.peso_inicial_gramas
          ? (this.gestacaoAtual.peso_inicial_gramas / 1000).toFixed(1)
          : null;
        this.pesoMask();
        this.form.gestacaoSolo = this.gestacaoAtual.gestacao_solo;
        this.form.gestacaoGemelar = this.gestacaoAtual.gestacao_gemelar;
        this.form.gestacaoGemelarObs = this.gestacaoAtual.gestacao_gemelar_obs;
        this.form.nome1 = this.gestacaoAtual.nome1;
        this.form.sexo1 = this.gestacaoAtual.sexo1;
        this.form.nome2 = this.gestacaoAtual.nome2;
        this.form.sexo2 = this.gestacaoAtual.sexo2;
        this.form.medico = this.gestacaoAtual.medico;
        this.form.pediatra = this.gestacaoAtual.pediatra;
        this.form.doula = this.gestacaoAtual.doula;
        this.form.fotografa = this.gestacaoAtual.fotografa;
        // local
        const localParto = _.get(this.gestacaoAtual, 'local_parto', '');
        const local = localParto ? _.get(localPartoLowerValues, _.toLower(localParto.trim()), '') : '';
        this.form.localParto = localParto ? local || 'outro' : null;
        this.form.localPartoOutro = localParto && !local ? localParto : null;
        this.form.obs_pre_natal = this.gestacaoAtual.obs_pre_natal;
        this.form.flagPa = this.gestacaoAtual.flag_pa;
        this.form.flagDg = this.gestacaoAtual.flag_dg;
        this.form.flagRc = this.gestacaoAtual.flag_rc;
        this.form.flagHg = this.gestacaoAtual.flag_hg;
        this.form.flagRhNegativo = this.gestacaoAtual.flag_rh_negativo;
        this.form.flagAr = this.gestacaoAtual.flag_ar;
        this.form.flagHt = this.gestacaoAtual.flag_ht;
        this.form.flagTf = this.gestacaoAtual.flag_tf;
        this.form.primeira_gestacao = this.gestacaoAtual.primeira_gestacao;
      }
      this.loading.form = false;
    },
    alturaMask() {
      if (!this.form.alturaM) return;
      this.form.alturaM = decimalBrMask(this.form.alturaM, 2);
    },
    pesoMask() {
      if (!this.form.pesoInicialKg) return;
      this.form.pesoInicialKg = decimalBrMask(this.form.pesoInicialKg, 1);
    },
    calculaDppDum(): void {
      this.dppDumInvalida = false;
      if (!this.form.dataUltimaMenstruacao) {
        return;
      }
      const momentDate = moment(this.form.dataUltimaMenstruacao);
      if (!momentDate.isValid()) {
        this.dppDumInvalida = true;
        return;
      }
      const days = moment().diff(momentDate, 'days');
      if (days < 0) {
        this.dppDumInvalida = true;
        return;
      }
      this.igDumSemanas = Math.floor(days / 7);
      this.igDumDias = days % 7;
    },
    minMaxDia() {
      if (Number(this.form.igExameUsDias) > 6) {
        this.form.igExameUsDias = 6;
      } else if (Number(this.form.igExameUsDias) < 0) {
        this.form.igExameUsDias = 0;
      }
    },
    minMaxSemana() {
      if (Number(this.form.igExameUsSemanas) > 99) {
        this.form.igExameUsSemanas = 99;
      } else if (Number(this.form.igExameUsSemanas) < 0) {
        this.form.igExameUsSemanas = 0;
      }
    },
    calculaDppUs(): void {
      this.dppUsInvalida = false;
      if (!this.form.dataExameUs) {
        return;
      }
      const momentDate = moment(this.form.dataExameUs)
        .subtract(Number(this.form.igExameUsSemanas), 'w')
        .subtract(Number(this.form.igExameUsDias), 'd')
        .add(40, 'w');
      if (!momentDate.isValid()) {
        this.dppUsInvalida = true;
        return;
      }
      this.$set(this.form, 'dataProvavelPartoUs', momentDate.utc().format('YYYY-MM-DD'));
    },
    igExameUs(): number | null {
      const igExameUsDias = Number(this.form.igExameUsSemanas * 7)
        + Number(this.form.igExameUsDias);
      if (igExameUsDias > 0) {
        return igExameUsDias;
      }
      return null;
    },
    dppFinalDum() {
      if (this.form.dppFinalDum) {
        if (!this.form.dataUltimaMenstruacao) {
          this.form.dppFinalDum = false;
        } else {
          this.form.dppFinalUs = false;
        }
      }
    },
    dppFinalUs() {
      if (this.form.dppFinalUs) {
        if (!this.form.dataExameUs) {
          this.form.dppFinalUs = false;
        } else {
          this.form.dppFinalDum = false;
        }
      }
    },
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer');
      this.formGestacaoAtual.resetValidation();
    },
    // eslint-disable-next-line func-names
    submitFormEditDebounce: _.debounce(async function () { await this.submitFormEdit(); }, 200),
    async submitFormEdit() {
      this.loading.submit = true;
      if (!this.formGestacaoAtual.validate()) {
        this.loading.submit = false;
        return;
      }
      let dppFinal: DppFinal | null = null;
      if (this.form.dppFinalDum) {
        dppFinal = DppFinal.M;
      } else if (this.form.dppFinalUs) {
        dppFinal = DppFinal.U;
      }
      const formData: GestacaoFormData = {
        id: this.gestacaoAtual.id,
        paciente_id: this.paciente.id,
        atual: true,
        dpp_final: dppFinal,
        peso_inicial_gramas: pesoGramas(this.form.pesoInicialKg),
        data_ultima_menstruacao: this.form.dataUltimaMenstruacao
          ? moment(this.form.dataUltimaMenstruacao).toDate()
          : null,
        ig_exame_us_dias: this.igExameUs(),
        data_exame_us: this.form.dataExameUs
          ? moment(this.form.dataExameUs).toDate()
          : null,
        data_provavel_parto_us: this.form.dataProvavelPartoUs
          ? moment(this.form.dataProvavelPartoUs).toDate()
          : null,
        gestacao_gemelar: this.form.gestacaoGemelar,
        gestacao_gemelar_obs: this.form.gestacaoGemelar ? this.form.gestacaoGemelarObs : null,
        gestacao_solo: this.form.gestacaoSolo,
        nome1: this.form.nome1,
        sexo1: this.form.sexo1,
        nome2: this.form.gestacaoGemelar ? this.form.nome2 : null,
        sexo2: this.form.gestacaoGemelar ? this.form.sexo2 : null,
        medico: this.form.medico,
        pediatra: this.form.pediatra,
        doula: this.form.doula,
        fotografa: this.form.fotografa,
        local_parto: this.form.localParto === 'outro'
          ? this.form.localPartoOutro
          : this.form.localParto,
        obs_pre_natal: this.form.obs_pre_natal,
        flag_pa: this.form.flagPa,
        flag_dg: this.form.flagDg,
        flag_rc: this.form.flagRc,
        flag_hg: this.form.flagHg,
        flag_rh_negativo: this.form.flagRhNegativo,
        flag_ar: this.form.flagAr,
        flag_ht: this.form.flagHt,
        flag_tf: this.form.flagTf,
        primeira_gestacao: this.form.primeira_gestacao,
        altura_cm: alturaCm(this.form.alturaM),
      };
      try {
        const response = await Requester.gestacao.alteraGestacao(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualiza-gestacao', response.data);
          this.$emit('atualizaAlturaPaciente', formData.altura_cm);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Gestação atual atualizada com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
      this.loading.submit = false;
    },
    // eslint-disable-next-line func-names
    cancelarDebounce: _.debounce(function () { this.cancelar(); }, 200),
    cancelar() {
      this.$emit('cancelar');
      this.formGestacaoAtual.resetValidation();
    },
    // eslint-disable-next-line func-names
    submitFormNovaDebounce: _.debounce(async function () { await this.submitFormNova(); }, 200),
    async submitFormNova() {
      this.loading.submit = true;
      if (!this.formGestacaoAtual.validate()) {
        this.loading.submit = false;
        return;
      }
      let dppFinal: DppFinal | null = null;
      if (this.form.dppFinalDum) {
        dppFinal = DppFinal.M;
      } else if (this.form.dppFinalUs) {
        dppFinal = DppFinal.U;
      }
      const formData: GestacaoFormData = {
        paciente_id: this.paciente.id,
        atual: true,
        dpp_final: dppFinal,
        peso_inicial_gramas: pesoGramas(this.form.pesoInicialKg),
        data_ultima_menstruacao: this.form.dataUltimaMenstruacao
          ? moment(this.form.dataUltimaMenstruacao).toDate()
          : null,
        ig_exame_us_dias: this.igExameUs(),
        data_exame_us: this.form.dataExameUs
          ? moment(this.form.dataExameUs).toDate()
          : null,
        data_provavel_parto_us: this.form.dataProvavelPartoUs
          ? moment(this.form.dataProvavelPartoUs).toDate()
          : null,
        gestacao_gemelar: this.form.gestacaoGemelar,
        gestacao_gemelar_obs: this.form.gestacaoGemelar ? this.form.gestacaoGemelarObs : null,
        gestacao_solo: this.form.gestacaoSolo,
        nome1: this.form.nome1,
        sexo1: this.form.sexo1,
        nome2: this.form.gestacaoGemelar ? this.form.nome2 : null,
        sexo2: this.form.gestacaoGemelar ? this.form.sexo2 : null,
        medico: this.form.medico,
        pediatra: this.form.pediatra,
        doula: this.form.doula,
        fotografa: this.form.fotografa,
        local_parto: this.form.localParto === 'outro'
          ? this.form.localPartoOutro
          : this.form.localParto,
        obs_pre_natal: this.form.obs_pre_natal,
        flag_pa: this.form.flagPa,
        flag_dg: this.form.flagDg,
        flag_rc: this.form.flagRc,
        flag_hg: this.form.flagHg,
        flag_rh_negativo: this.form.flagRhNegativo,
        flag_ar: this.form.flagAr,
        flag_ht: this.form.flagHt,
        flag_tf: this.form.flagTf,
        primeira_gestacao: this.form.primeira_gestacao,
        altura_cm: alturaCm(this.form.alturaM),
      };
      try {
        const response = await Requester.gestacao.criaGestacao(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('novaGestacao', response.data);
          this.$emit('atualizaAlturaPaciente', formData.altura_cm);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Gestação atual cadastrada com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
